export default __webpack_public_path__ + "static/images/jigang-weapp.4e6e5ee7.png";